import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import { CookieConsent } from "@/components/CookieConsent";
import Dashboard from "@/pages/Dashboard";
import People from "@/pages/People";
import EmployeeProfile from "@/pages/EmployeeProfile";
import Work from "@/pages/Work";
import Templates from "@/pages/Templates";
import Regions from "@/pages/Regions";
import UsersPage from "@/pages/Users";
import Administration from "@/pages/Administration";
import GdprRegister from "@/pages/GdprRegister";
import TrainingMatrix from "@/pages/TrainingMatrix";
import Reviews from "@/pages/Reviews";
import Notifications from "@/pages/Notifications";
import Calendar from "@/pages/Calendar";
import RegionDetail from "@/pages/RegionDetail";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-orange-500" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, ready } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/login" element={ready && user ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/people" element={<Protected><People /></Protected>} />
      <Route path="/people/:id" element={<Protected><EmployeeProfile /></Protected>} />
      <Route path="/work" element={<Protected><Work /></Protected>} />
      <Route path="/calendar" element={<Protected><Calendar /></Protected>} />
      <Route path="/training-matrix" element={<Protected><TrainingMatrix /></Protected>} />
      <Route path="/reviews" element={<Protected><Reviews /></Protected>} />
      <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
      <Route path="/regions/:id" element={<Protected><RegionDetail /></Protected>} />
      <Route path="/templates" element={<Protected><Templates /></Protected>} />
      <Route path="/regions" element={<Protected><Regions /></Protected>} />
      <Route path="/users" element={<Protected><UsersPage /></Protected>} />
      <Route path="/administration" element={<Protected><Administration /></Protected>} />
      <Route path="/gdpr-register" element={<Protected><GdprRegister /></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <CookieConsent />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
